/*
* Direct Service call to the Property Service (avoiding OnCloud).
*/
Property_service = {
	config : {},
	queue: [],
	init : function(){
		// Setup configuration.
		Property_service.config.abn = sh__site_object.property_options.client.abn;
		Property_service.config.license_1 = sh__site_object.property_options.client.sh_licence_1;
		Property_service.config.property_type = 'holiday';
		Property_service.config.title_field_id = sh__site_object.property_options.property_alt_title_field_id;
	}
	,
	get_data : function( pm_config = {} )
	{
		var result = {};
		result.success = false;
		
		// Validation.
		if (typeof pm_config.end_point == 'undefined')
		{
			result.error = 'No endpoint supplied';
			return(result);
		}
		
		// Check queue.
		var check_queue = Property_service.check_queue(pm_config);
		if(!check_queue)
		{
			console.log('ALREADY QUEUED: ',Property_service.queue);
			result.error = 'Call already queued';
			return(result);
		}
		
		// Assemble POST parameters.
		var post_data = Property_service.get_post_data(pm_config.end_point);
		
		// Get the URL to call.
		var data_url = "https://svc.sherlock.com.au/PropertyService/Service.php/" + pm_config.end_point;
		
		jQuery.ajax({
			url: data_url,
			type: "POST",
			data: JSON.stringify(post_data),
			contentType: "text/plain; charset=utf-8",
			dataType: "json",
			success: function (result) {
				if(result.isSuccess){
					var properties = result.properties.holiday;
					
					// Emit event. After Property Service data retrieval.
					var response = {};
					response.success = true;
					response.url = data_url;
					response.config = pm_config;
					response.post = post_data;
					response.data = result;
					jQuery(document).trigger('property_service_data_retrieval',response);
				}
			}
		});
		
		// We reached the end.
		result.success = true;
		
		return(result);
	}
	,
	get_post_data : function(pm_end_point = '', queue_id = '', client = '')
	{
		// Assemble POST parameters.
		var post_data = new Object();
		
		// Get client information.
		post_data.ABN = Property_service.config.abn; //pm_options.abn;
		post_data.license1 = Property_service.config.license_1; //pm_options.license_1;
		post_data.propertyType = Property_service.config.property_type; //pm_options.property_type;
		
		switch(pm_end_point)
		{
			case('getProperties'):
				//full-property-list
				// Get call parameters.
				post_data.pagingOptions = {};
				//post_data.pagingOptions.pageNumber = ($('#i_search_pagenumber').val() == '' ? 0 : Number($('#i_search_pagenumber').val()));
				//post_data.pagingOptions.rowsPerPage = ($('#i_search_rowsperpage').val() == '' ? 0 : Number($('#i_search_rowsperpage').val()));
				post_data.pagingOptions.sortItem = 'alphabetical';
				post_data.pagingOptions.sortDirection = 'asc';
				post_data.searchOptions = {};
				post_data.searchOptions.titleField = (Property_service.config.title_field_id != '') ? Property_service.config.title_field_id : '';
				
				break;
		}
		
		return(post_data);
	}
	,
	check_queue : function( pm_config = {} )
	{
		// Is call using the queue. Default is true.
		var use_queue = ( typeof pm_config.use_queue !== 'undefined' ) ? pm_config.use_queue : true;
		
		// Exit if we are not using the queue.
		if( !use_queue )
		{
			return(true);
		}
		
		// Queue functionality. Disallow repeated calls. One call per Queue ID.
		let allow_call = ( Property_service.queue.indexOf(pm_config.queue_id) < 0 );
		if( allow_call )
		{
			// Add the call to the queue.
			Property_service.queue.push(pm_config.queue_id);
		}
		
		return(allow_call);
	}
}

jQuery(document).ready(function(jQuery){
	Property_service.init();
});